import { STORE_DETAIL } from "../../data/constants";

export const body = ({
  formInfo,
  total,
  subtotal,
  discount,
  shippingCost,
  cart,
  note,
  currencySelect,
  letter,
  radio,
  customizationCost,
  customizationCostUSD,
  orderInfo: { orderNumber },
  paymentMethod,
  totalUSD,
  usdSubTotal,
  origin,
}) => {
  const currency = currencySelect.currency.currency
    ? currencySelect.currency.currency
    : "HNL";
  const currencyValue =
    currency === "HNL" ? 0 : currencySelect.currency.currencyLayer;
  return {
    origin,
    invoiceNumber: orderNumber,
    discountPCT: discount,
    subtotal: Math.round((subtotal * 100) / 100).toFixed(2),
    totalUSD: Math.round(totalUSD).toFixed(2),
    usdSubTotal: Math.round(usdSubTotal).toFixed(2),
    total: Math.round(total).toFixed(2),
    discount: Math.round((subtotal * discount * 100) / 100).toFixed(2),
    currency,
    shipping_cost: (
      Math.round(
        (currency === "HNL"
          ? shippingCost
          : shippingCost / currencyValue.data.value) * 100
      ) / 100
    ).toFixed(2),
    business: STORE_DETAIL,
    buyer: {
      names: formInfo.names.value,
      surnames: formInfo.surnames.value,
      email: formInfo.email.value,
      phone: formInfo.phone.value,
    },
    shipping: {
      name: formInfo.recipientName.value,
      phone: formInfo.recipientPhone.value,
      date: formInfo.date.value,
      afternoon: formInfo.afternoon.value,
      addressLine1: formInfo.addressLine1.value,
      addressLine2: formInfo.addressLine2.value,
      department: formInfo.department.value,
      city: formInfo.municipality.value,
    },
    order: {
      note: note,
      letter: letter,
      showName: radio,
      paymentMethod,
      items: cart.map((item) => {
        let customCost = item.customText
          ? (
              Math.round(
                (currency === "HNL"
                  ? customizationCost
                  : customizationCostUSD) * 100
              ) / 100
            ).toFixed(2)
          : 0;

        return {
          ...item,
          price:
            !currencySelect || currencySelect.loading
              ? 0
              : currency === "HNL"
              ? (Math.round(Math.ceil(item.price) * 100) / 100).toFixed(2)
              : (
                  Math.round(
                    (Math.ceil(item.price / currencyValue.data.value) - 0.01) *
                      100
                  ) / 100
                ).toFixed(2),
          customizationCost: customCost,
          total:
            !currencySelect || currencySelect.loading
              ? 0
              : currency === "HNL"
              ? (
                  Math.round(
                    (item.quantity * item.price + parseFloat(customCost)) * 100
                  ) / 100
                ).toFixed(2)
              : (
                  Math.round(
                    ((Math.ceil(item.price / currencyValue.data.value) - 0.01) *
                      item.quantity +
                      parseFloat(customCost)) *
                      100
                  ) / 100
                ).toFixed(2),
        };
      }),
    },
  };
};
